module.exports = __webpack_public_path__ + "static/review2-min-8da17b8fbb92e7c37cf16ea6c38e468f.webp";